import * as React from 'react';
import * as styled from './styled';
import * as forms from './components';

/**
 * The settings part of the task.
 * @return {React.ReactElement}
 * @constructor
 */
export default function Settings(): React.ReactElement {
  return (
    <styled.Wrapper>
      <forms.Limit />
      <forms.Attempts />
      <forms.Estimate />
    </styled.Wrapper>
  );
}
